<div class="fluid-container">
  <div class="row pt-4 d-flex align-items-center" *ngIf="isSimplifyH1b ? false : true">
    <div class="col-md-9 step-title p-0" *ngIf="!isWizard">
      <div class="w-100 d-flex">
        <h5 class="mb-0">Educational Details</h5>
      </div>      
    </div>
    <div class="col-md-2 editBtn" *ngIf="!isWizard">
      <lib-step-status-update-component-library
        [visaType]="inputData.caseType != 'I130' ? inputData.visatype : inputData.caseType" [stepDetails]="stepDetails"
        type="EDIT">
      </lib-step-status-update-component-library>
    </div>
    <div class="col-md-1 pr-0 d-flex justify-content-end" *ngIf="!isWizard">
      <lib-maximize-dialog-library [configData]="{'layoutCode':inputData?.layoutCode}"></lib-maximize-dialog-library>
      <i (click)="handleClose();" class="close-icon pi pi-times"></i>
    </div>
  </div>
  <div class="row" *ngIf="isSimplifyH1b ? false : true">
    <div class="col-md-12 p-0">
      <!-- <lib-assigning-task-library [visaType]="inputData.visatype" [stepDetails]="stepDetails"
        (updateStatus)="updateStepStatus($event)">
      </lib-assigning-task-library> -->
      <lib-assigning-task-library *ngIf="!isWizard" [visaType]="inputData.visatype" [stepDetails]="stepDetails"
        (updateStatus)="updateStepStatus($event)" [isViewMode]="this.inputData['isViewMode']"
        [isCaseRequest]="this.inputData['isCaseRequest']">
      </lib-assigning-task-library>
    </div>
  </div>
  <ng-container *ngIf="!isWizard">
    <p-divider class="header-divider" *ngIf="isSimplifyH1b ? false : true"></p-divider>
  </ng-container>
  <div [ngClass]="isWizard ? 'main-body-remove-scroll' : 'main-body footer-adjust-v2'">
    <ng-container *ngIf="!isWizard">
      <lib-last-update-library *ngIf="isSimplifyH1b ? false : true" [inputDetails]="stepDetails" [primaryData]="inputData" sectionCode="BEN_EDU">
      </lib-last-update-library>
    </ng-container>
    <div class="btn-group" *ngIf="isEducationView">
      <button pButton [disabled]="disabledControls" (click)="sycProfilePitition()" type="button"
        class="p-button-rounded p-button-text pull-right syncBtn" pTooltip="Sync With Profile"
        icon="pi pi-arrow-right-arrow-left">SYNC</button>
      <button pButton [disabled]="disabledControls" (click)="syncEduMerge()" type="button"
        class="p-button-rounded p-button-text pull-right syncBtn" pTooltip="Merge Both Profile & Petition Data" icon="pi pi-sync
      ">MERGE</button>
      <button pButton [disabled]="disabledControls" (click)="syncEduReset()" type="button"
        class="p-button-rounded p-button-text pull-right syncBtn" pTooltip="Reset Petition Data"
        icon="pi pi-undo">RESET</button>
      <button button pButton class="p-button-outlined  btnData" pTooltip="Edit" [disabled]="disabledControls"
        (click)="onClickEditImmigation()"><mat-icon class="mr-1 icn">edit</mat-icon>Edit</button>
    </div>
    <!-- <div *ngIf="!isEducationView">
      <div class="col-12 text-right mb-3" >
        <mat-button-toggle-group [value]="selectedState" (change)="onChange($event)">
            <mat-button-toggle value="simple">Simple Profile</mat-button-toggle>
            <mat-button-toggle value="complete">Complete Profile</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div> -->
      <div *ngIf="!isEducationView && selectedState == 'simple'" class="mb-3">
        <lib-generic-beneficiary-education [isSyncPage]="true" [isUsedForBeneEdit]="false" [inputData]="primaryData" [isWizard]="true">
        </lib-generic-beneficiary-education>
        <!-- <lib-simple-education-detail-library [isWizard]="isWizard" [wizardData]="primaryData"></lib-simple-education-detail-library> -->
      </div>

    <ng-container *ngIf="isEducationView">
      <div class="row pt-3">
        <div class="row col-md-12 p-0 pb-2 d-flex align-items-center profile-title">
          <div class="col p-0 rowHeader">
            <h6>Education Details</h6>
          </div>
        </div>
        <p-table [columns]="educationCols" *ngIf="educationList && educationList.length > 0; else noEducation"
          [value]="educationList" dataKey="id">
          <ng-template pTemplate="header" let-columns>
            <tr class="text-uppercase">
              <th style="width: 3rem" class="tableHeader"> </th>
              <th class="tableHeader" *ngFor="let col of columns">
                {{col.header}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
            <tr class="tableData">
              <td class="expandIcon eduTable">
                <button type="button" pButton pRipple [pRowToggler]="rowData"
                  class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                </button>
              </td>
              <td class="eduTable" *ngFor="let col of columns">
                <span>
                  {{rowData[col.field]}}
                </span>
                <span *ngIf="col.field === 'degree'">
                  {{rowData['degreeType'] ? rowData['degreeType']['name'] : rowData['degreeType']}}
                </span>
                <span class="table-btn" *ngIf="col.field === 'action'">
                  <button type="button" pButton icon="pi pi-trash" (click)="deleteEducationList(rowData)"
                    class="p-button-text p-button-rounded btnIcon btnTrash" [disabled]="disabledControls"
                    pTooltip="Delete"></button>
                  <button type="button" pButton icon="pi pi-refresh" pTooltip="Sync"
                    (click)="syncSingleEduaction(rowData)" class="p-button-text p-button-rounded refreshIcon "
                    [disabled]="disabledControls"></button>
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-subeducationlist>
            <tr>
              <td colspan="8">
                <div class="p-p-3 sub-task-type">
                  <p-table class="sub-task-table profile-table" [columns]='educationSubCols'
                    [value]="[subeducationlist]" dataKey="id">
                    <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns">
                {{col.header}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
              <td *ngFor="let col of columns">
                <span>
                  {{rowData[col.field]}}
                </span>
                <span *ngIf="col.field === 'countryCode'">
                  {{rowData['country'] && rowData['country']['countryName'] ? rowData['country']['countryName'] : ''}}
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6">No Data</td>
            </tr>
          </ng-template>
        </p-table>
        <div class="courseList pt-4" *ngIf="subeducationlist.courses && subeducationlist.courses.length >0">
          <h6>List of Courses</h6>
          <p-card class="courses-card">
            <div class="row courses courses-title d-flex align-items-center"
              *ngFor="let item of subeducationlist.courses; let i = index">
              <div class="col-md-11">
                <span class="duty-list">{{i+1}}</span>&nbsp;&nbsp; <b class="courseName">{{ item.courseName }}</b>
              </div>
              <div class="col-md-1 pull-right">
                <button pButton type="button" icon="pi pi-trash" pTooltip="Delete" [disabled]="disabledControls"
                  (click)="deleteCoursesList(subeducationlist, item)" class="p-button-text p-button-rounded "></button>
              </div>
            </div>
          </p-card>
        </div>
        <div class="courseList pt-4" *ngIf="subeducationlist.documents && subeducationlist.documents.length >0">
          <h6>List of Documents</h6>
          <p-card class="courses-card">
            <div class="row document-header">
              <div class="col-md-5">
                <h6>Document Type</h6>
              </div>
              <div class="col-md-5">
                <h6>Document Name </h6>
              </div>
              <div class="col-md-2">
                <h6>Action</h6>
              </div>
            </div>
            <div class="row courses courses-title d-flex align-items-center"
              *ngFor="let item of subeducationlist.documents; let i = index">
              <div class="col-md-5">
                <span class="duty-list">{{i+1}}</span>
                &nbsp;&nbsp; <b class="courseName">
                  {{ item?.fileCategory.code === 'OTHER' && item.isPresent ? item.fileCategoryOtherName :
                  item?.fileCategory.name }}
                </b>
              </div>
              <div class="col-md-5">
                <span *ngIf="item.isPresent" class="docFileName">
                  {{ item.fileName}}
                </span>
                <span *ngIf="!item.isPresent" class="redColor d-flex align-items-center">
                  <i class="pi pi-exclamation-triangle pr-2"></i> Document Missing
                </span>
              </div>
              <div class="col-md-2 pull-right d-flex align-items-center" *ngIf="item?.isPresent">
                <button pButton type="button" icon="pi pi-eye" pTooltip="View" [disabled]="!item.fileLocation"
                  (click)="openDoc(item)" class="p-button-text p-button-rounded"></button>
                <lib-send-back-component *ngIf="userType !== 'Beneficiary'" [disabledControls]="disabledControls"
                  [stepDetails]="stepDetails" [primaryData]="primaryData" [item]="item">
                </lib-send-back-component>
                <button pButton type="button" icon="pi pi-trash" pTooltip="Delete" [disabled]="disabledControls"
                  (click)="deleteDocumentsList(subeducationlist, item)"
                  class="p-button-text p-button-rounded "></button>
              </div>
              <div class="col-md-2 pull-right" *ngIf="!item?.isPresent">
                <notification-component-library *ngIf="userType !== 'Beneficiary'" [disabledControls]="disabledControls"
                  [stepDetails]="stepDetails" [destination]="notifyDestinationUser" [primaryData]="primaryData"
                  [item]="item">
                </notification-component-library>
              </div>
            </div>
          </p-card>
        </div>
      </div>
      </td>
      </tr>
      </ng-template>
      </p-table>
      <ng-template #noEducation>
        <p class="pb-3 w-100" style="border-bottom: 1px dashed lightgray;">Education details need to be filled under individual/beneficiary profile before syncing it here.</p>
      </ng-template>

  </div>

  <div class="row pt-3">
    <div class="row col-md-12 p-0 pb-2 d-flex align-items-center profile-title">
      <div class="col p-0 rowHeader">
        <h6>Training Details</h6>
      </div>
      <div class="col p-0 btn-group">
        <button pButton [disabled]="disabledControls" (click)="syncTraMerge()" type="button"
          class="p-button-rounded p-button-text pull-right syncBtn" pTooltip="Merge Both Profile & Petition Data" icon="pi pi-sync
      ">MERGE</button>
        <button pButton [disabled]="disabledControls" (click)="syncTraReset()" type="button"
          class="p-button-rounded p-button-text pull-right syncBtn" pTooltip="Reset Petition Data"
          icon="pi pi-undo">RESET</button>
      </div>
    </div>
    <p-table [columns]="trainingCols" *ngIf="trainingList && trainingList.length > 0; else noTraining"
      class="profile-table pa-table im-card-no-border-table im-card-table-noborder-spacing table"
      styleClass="p-datatable-gridlines" [value]="trainingList" dataKey="id" (onRowExpand)="onRowExpand($event)">
      <ng-template pTemplate="header" let-columns>
        <tr class="text-uppercase">
          <th style="width: 3rem"> </th>
          <th *ngFor="let col of columns">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
        <tr>
          <td class="expandIcon">
            <button type="button" pButton pRipple [pRowToggler]="rowData"
              class="p-button-text p-button-rounded p-button-plain"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
            </button>
          </td>
          <td> {{rowData['name']}} </td>
          <td class="text-truncate"> {{rowData['subjects']}} </td>
          <td> {{rowData['institution']}} </td>
          <td> {{rowData['startDate'] | VisaDateFormat }} </td>
          <td> {{rowData['endDate'] | VisaDateFormat}} </td>
          <td class="table-btn">
            <button type="button" pTooltip="Delete" pButton icon="pi pi-trash" (click)="deleteTrainingList(rowData)"
              class="p-button-text p-button-rounded btnTrash" [disabled]="disabledControls"></button>
            <button type="button" pTooltip="Sync" pButton icon="pi pi-refresh" (click)="handleTrainingSync(rowData)"
              class="p-button-text p-button-rounded refreshIcon" [disabled]="disabledControls"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-subeducationlist>
        <tr>
          <td colspan="7">
            <div class="p-p-3 sub-task-type">
              <div class="courseList pt-2" *ngIf="subeducationlist.subjects && subeducationlist.subjects.length >0">
                <h6>Topic of Study</h6>
                <p-card class="courses-card">
                  <div class="row courses courses-title d-flex align-items-center">
                    <div class="col-md-12">
                      {{ subeducationlist.subjects }}
                    </div>
                  </div>
                </p-card>
              </div>
              <div class="courseList pt-4" *ngIf="subeducationlist.documents && subeducationlist.documents.length >0">
                <h6>List of Documents</h6>
                <p-card class="courses-card">
                  <div class="row document-header">
                    <div class="col-md-5">
                      <h6>Document Type </h6>
                    </div>
                    <div class="col-md-5">
                      <h6>Document Name</h6>
                    </div>
                    <div class="col-md-2">
                      <h6>Action</h6>
                    </div>
                  </div>
                  <div class="row courses courses-title d-flex align-items-center"
                    *ngFor="let item of subeducationlist.documents; let i = index">
                    <div class="col-md-5">
                      <span class="duty-list">{{i+1}}</span>
                      <span>
                        {{ item?.fileCategory.code === 'OTHER' && item.isPresent ? item.fileCategoryOtherName :
                        item?.fileCategory.name }}
                      </span>
                    </div>
                    <div class="col-md-5">
                      <span *ngIf="item.isPresent">
                        {{ item.fileName}}
                      </span>
                      <span *ngIf="!item.isPresent" class="redColor d-flex align-items-center">
                        <i class="pi pi-exclamation-triangle pr-2"></i> Document Missing
                      </span>
                    </div>
                    <div class="col-md-2 pull-right d-flex align-items-center" *ngIf="item?.isPresent">
                      <button pButton type="button" icon="pi pi-eye" pTooltip="View" [disabled]="!item.fileLocation"
                        (click)="openDoc(item)" class="p-button-text p-button-rounded"></button>
                      <lib-send-back-component *ngIf="userType !== 'Beneficiary'" [disabledControls]="disabledControls"
                        [stepDetails]="stepDetails" [primaryData]="primaryData" [item]="item">
                      </lib-send-back-component>
                      <button pButton type="button" icon="pi pi-trash" [disabled]="disabledControls"
                        (click)="deleteTrainingDocumentsList(subeducationlist, item)"
                        class="p-button-text p-button-rounded "></button>
                    </div>
                    <div class="col-md-2 pull-right" *ngIf="!item?.isPresent">
                      <notification-component-library *ngIf="userType !== 'Beneficiary'"
                        [disabledControls]="disabledControls" [stepDetails]="stepDetails"
                        [destination]="notifyDestinationUser" [primaryData]="primaryData" [item]="item">
                      </notification-component-library>
                      <!-- <button type="button" pButton icon="pi pi-ban" pTooltip="Not Applicable"
                                                class="p-button-text p-button-rounded"
                                                [disabled]="disabledControls"></button> -->
                    </div>
                  </div>
                </p-card>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template #noTraining>
    <p class="pl-3 pb-3 w-100" style="border-bottom: 1px dashed lightgray;">Training details need to be filled under individual/beneficiary profile before syncing it here.</p>
  </ng-template>

  <div class="row pt-3 pb-0">
    <div class="row col-md-12 p-0 pb-2 d-flex align-items-center profile-title">
      <div class="col p-0 rowHeader">
        <h6>Licenses & Certifications Details</h6>
      </div>
      <div class="col p-0 btn-group">
        <button pButton [disabled]="disabledControls" (click)="syncLinMerge()" type="button"
          class="p-button-rounded p-button-text pull-right syncBtn" pTooltip="Merge Both Profile & Petition Data" icon="pi pi-sync
      ">MERGE</button>
        <button pButton [disabled]="disabledControls" (click)="syncLinReset()" type="button"
          class="p-button-rounded p-button-text pull-right syncBtn" pTooltip="Reset Petition Data"
          icon="pi pi-undo">RESET</button>
      </div>
    </div>
    <p-table [columns]="linceseCols" *ngIf="licensesList && licensesList.length > 0; else noLicense"
      class=" im-card-no-border-table im-card-table-noborder-spacing table" styleClass="p-datatable-gridlines"
      [value]="licensesList" dataKey="id" (onRowExpand)="onRowExpand($event)">
      <ng-template pTemplate="header" let-columns>
        <tr class="text-uppercase">
          <th style="width: 3rem"> </th>
          <th *ngFor="let col of columns">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
        <tr>
          <td class="expandIcon">
            <button type="button" pButton pRipple [pRowToggler]="rowData"
              class="p-button-text p-button-rounded p-button-plain"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
            </button>
          </td>
          <td> {{rowData['name']}} </td>
          <td class="text-truncate"> {{rowData['subjects']}} </td>
          <td> {{rowData['institution']}} </td>
          <td> {{rowData['startDate'] | VisaDateFormat}} </td>
          <td> {{rowData['endDate'] | VisaDateFormat}} </td>
          <td class="table-btn">
            <button type="button" pButton icon="pi pi-trash" pTooltip="Delete" (click)="deleteLicensesList(rowData)"
              class="p-button-text p-button-rounded btnTrash" [disabled]="disabledControls"></button>
            <button type="button" pButton icon="pi pi-refresh" pTooltip="Sync" (click)="handleLicensesSync(rowData)"
              class="p-button-text p-button-rounded refreshIcon" [disabled]="disabledControls"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-subeducationlist>
        <tr>
          <td colspan="7">
            <div class="p-p-3 sub-task-type">
              <div class="courseList pt-2" *ngIf="subeducationlist.subjects && subeducationlist.subjects.length >0">
                <h6>Topic of Study</h6>
                <p-card class="courses-card">
                  <div class="row courses courses-title d-flex align-items-center">
                    <div class="col-md-12">
                      {{ subeducationlist.subjects }}
                    </div>
                  </div>
                </p-card>
              </div>
              <div class="courseList pt-4" *ngIf="subeducationlist.documents && subeducationlist.documents.length >0">
                <h6>List of Documents</h6>
                <p-card class="courses-card">
                  <div class="row document-header">
                    <div class="col-md-5">
                      <h6>Document Type</h6>
                    </div>
                    <div class="col-md-5">
                      <h6>Document Name</h6>
                    </div>
                    <div class="col-md-2">
                      <h6>Action</h6>
                    </div>
                  </div>
                  <div class="row courses courses-title d-flex align-items-center"
                    *ngFor="let item of subeducationlist.documents; let i = index">
                    <div class="col-md-5">
                      <span class="duty-list">{{i+1}}</span>
                      <span>
                        {{ item?.fileCategory.code === 'OTHER' && item.isPresent ? item.fileCategoryOtherName :
                        item?.fileCategory.name }}
                      </span>
                    </div>
                    <div class="col-md-5">
                      <span *ngIf="item.isPresent">
                        {{ item.fileName}}
                      </span>
                      <span *ngIf="!item.isPresent" class="redColor d-flex align-items-center">
                        <i class="pi pi-exclamation-triangle pr-2"></i> Document Missing
                      </span>
                    </div>
                    <div class="col-md-2 pull-right d-flex align-items-center" *ngIf="item?.isPresent">
                      <button pButton type="button" icon="pi pi-eye" pTooltip="View" [disabled]="!item.fileLocation"
                        (click)="openDoc(item)" class="p-button-text p-button-rounded"></button>
                      <lib-send-back-component *ngIf="userType !== 'Beneficiary'" [disabledControls]="disabledControls"
                        [stepDetails]="stepDetails" [primaryData]="primaryData" [item]="item">
                      </lib-send-back-component>
                      <button pButton type="button" icon="pi pi-trash" pTooltip="Delete" [disabled]="disabledControls"
                        (click)="deleteLicensesDocumentsList(subeducationlist, item)"
                        class="p-button-text p-button-rounded"></button>
                    </div>
                    <div class="col-md-2 pull-right" *ngIf="!item?.isPresent">
                      <notification-component-library *ngIf="userType !== 'Beneficiary'"
                        [disabledControls]="disabledControls" [stepDetails]="stepDetails"
                        [destination]="notifyDestinationUser" [primaryData]="primaryData" [item]="item">
                      </notification-component-library>
                    </div>
                  </div>
                </p-card>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- <div class="row col-md-12 pt-4">
        <div class="col-md-8 p-0 profile-title">
            <h6>Education Summary</h6>
        </div>
        <div class="col-md-12 pl-0 pr-0">
            <lib-editor-library [events]="onSaveEmitSubject.asObservable()" (sendApiStatus)="getApiStatus($event)" [primaryData]="inputData"
                infoName="Education Detail" infoType="EDUCEXSUM" [disabledControls]="disabledControls"></lib-editor-library>
        </div>
    </div> -->
    <div class="row col-md-12 pl-0 pr-0 profile-title pt-3 rowHeader">
      <h6>Education Summary</h6>
      <div class="col-md-12 pl-0 pr-0">
        <lib-editor-library [events]="onSaveEmitSubject.asObservable()" (sendApiStatus)="getApiStatus($event)"
          [primaryData]="inputData" infoName="Education Detail" infoType="EDUCEXSUM"></lib-editor-library>
      </div>
    </div>


    <!-- <p-divider *ngIf="isSimplifyH1b ? false : true" class="w-100"></p-divider> -->
    <lib-custom-questionnaire *ngIf="!isWizard" [stepId]="primaryData.stepId" [taskId]="primaryData.taskId" [viewQuestions]="false"
      [showSaveBtn]="false" [loadedIn]="stepDetails.stepName" [isSection]="false" [isCustomTriggered]="isCustomTriggered">
    </lib-custom-questionnaire>
    <!-- <p-divider *ngIf="isSimplifyH1b ? false : true" class="w-100"></p-divider> -->

  </div>
  <ng-template #noLicense>
    <p class="pl-3 pb-3">License/certification details need to be filled under individual/beneficiary profile before syncing it here.</p>
  </ng-template>
  </ng-container>

  <!-- <ng-template #editImmigation>
    <div  *ngIf="!isEducationView && selectedState == 'complete'">
    <edit-education-details-tab [editEducationData]="inputData"></edit-education-details-tab>
    </div>
  </ng-template> -->

</div>
<p-divider *ngIf="isSimplifyH1b ? false : true"></p-divider>

<div class="row" *ngIf="isSimplifyH1b ? false : true">
  <div class="col-md-6" *ngIf="isEducationView">
    <button pButton type="button" label="Save" (click)="saveSummaryInfo()"
      [ngClass]="disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
      [disabled]="disabledControls"></button>

    <!-- <button pButton type="button" label="VERIFY" class="save-btn" (click)="handleVerify()"></button> -->
  </div>
  <div class="col-md-6" *ngIf="!isEducationView">
    <button pButton type="button" label="Close" (click)="saveCloseEditEducation()"
      [ngClass]="disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
      [disabled]="disabledControls"></button>
  </div>
  <div class="col-md-6 completeStep" *ngIf="!isWizard">
    <lib-step-status-update-component-library
      [visaType]="inputData.caseType != 'I130' ? inputData.visatype : inputData.caseType" [stepDetails]="stepDetails"
      [type]="typeOfButton" [showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end">
    </lib-step-status-update-component-library>
  </div>
</div>
<div class="row" *ngIf="isSimplifyH1b ? true : false">
  <div class="col-md-12 pt-3 customSave alignRight" *ngIf="isEducationView">
    <button pButton type="button" label="Save & Continue" (click)="saveSummaryInfo()"
      [ngClass]="disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
      [disabled]="disabledControls"></button>

    <!-- <button pButton type="button" label="VERIFY" class="save-btn" (click)="handleVerify()"></button> -->
  </div>
  <div class="col-md-12 customSave alignRight" *ngIf="!isEducationView">
    <button pButton type="button" label="Close" (click)="saveCloseEditEducation()"
      [ngClass]="disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
      [disabled]="disabledControls"></button>
  </div>
</div>
</div>